/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable import/prefer-default-export */
import {
    // unitBase,
    rowSpacing,
    fontSizeDesktop,
    // fontSize,
    enterpriseCSS,
} from './variables';

import { StatusTrackingBar } from './common/StatusTrackingBar';

export const DesktopOrderListStyle = (typography, palette) => {
    return {
        DesktopOrderListStyle: {
            maxWidth: palette.myAccount.container.maxWidth.upLarge,
            margin: '0 auto',
            marginBottom: rowSpacing,

            '& .order-list-wrapper': {
                boxShadow: '0px 0px 10px rgb(47 47 47 / 25%)',
            },

            '& .orderHeader': {
                alignItems: 'center',
                display: 'flex',
                fontSize: fontSizeDesktop.title,
                fontWeight: '700',
                textTransform: 'uppercase',
                padding: `${rowSpacing}px ${rowSpacing * 2}px`,
                backgroundColor: enterpriseCSS.palette.gray3,

                '& .orderHeaderItem': {
                    width: '100%',
                    '& .headerItemLabel': {
                        color: enterpriseCSS.palette.gray1,
                    },

                    '& .partOrderNumber': {
                        fontWeight: 'normal',
                    },

                    '& .orderDate': {
                        textTransform: 'initial',
                    },
                },
            },

            '& .orderItemGrid': {
                padding: `${rowSpacing}px ${rowSpacing * 2}px`,
                '&:not(:first-of-type) ': {
                    borderTop: `${'2px dashed'} ${enterpriseCSS.palette.gray3}`,
                },
            },

            '& .orderStatusInfo': {
                '& .orderDetail': {
                    marginTop: rowSpacing,
                    marginLeft: rowSpacing * 6,
                    '& .fedex-logo': {
                        marginLeft: '5px',
                    },
                },
                '& .deliveryText': {
                    maxWidth: '277px',
                },
                '& .subStatusContainer': {
                    marginLeft: rowSpacing * 9,
                    marginBottom: rowSpacing,
                },
            },

            '& .productInnerDiv': {
                minHeight: rowSpacing * 11,
                position: 'relative',

                '& .productImg': {
                    display: 'flex',
                    '& img': {
                        width: 120,
                        height: 130,
                    },
                    '& .productName': {
                        paddingLeft: 8,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        '& .subscription': {
                            marginTop: rowSpacing,
                            '& .subscriptionDelivery': {
                                display: 'block',
                            },
                        },
                        '& .productId': {
                            color: enterpriseCSS.palette.gray1,
                            textTransform: 'uppercase',
                            fontWeight: '700',
                            '& .productIdValue': {
                                fontWeight: 'normal',
                                textTransform: 'none',
                                color: enterpriseCSS.palette.body,
                            },
                        },
                        '& .reactMarkdownLink': {
                            '& p': {
                                marginBottom: '0px',
                            },
                        },
                    },
                },
            },

            '& .delay-container': {
                display: 'flex',
                alignItems: 'center',
                '& img': {
                    marginRight: '5px',
                },
            },
            // Status tracking bar
            ...StatusTrackingBar(typography, palette).StatusTrackingBar,
        },
    };
};
